import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "antd";
import ElapsedTime from "./ElapsedTime";
// import axios from '../../utils/BasicAuthAPI';
import moment from "moment";
import { Modal } from "antd";

import liracrypt from "../../../components/Liracrypt/liracrypt";
import SessionError from "../../../components/ApiErrorComp/SessionError";
import { useDispatch, useSelector } from "react-redux";
import NotificationModal from "./NotificationModal";
import NewGenerateIssue from "./NewGenerateIssue";
import { LoadingOutlined } from "@ant-design/icons";
import StablePrime from "../../../components/Tables/StablePrime";


const Andon = (props) => {
  const currentAndonStatus = useSelector(state => state.andonStatus);
  const andonstatus = useSelector(state => state.andonData)
  const antIcon = <LoadingOutlined style={{ fontSize: 20 }} spin />;
  const [btnText, setBtnText] = useState('Andon Call')

  const [isAndonCall, setIsAndonCall] = useState(false);
  const [displayElapsed, setDisplayElapsed] = useState(true);
  const [generateIssue, setGenerateIssue] = useState(false);
  const [acknowledgeIssue, setAcknowledgeIssue] = useState(false);
  const [runModeIssue, setRunModeIssue] = useState(false);
  const [showIssue, setShowIssue] = useState(false);
  const [generateChangeOver, setGenerateChangeOver] = useState(false);
  const [runChangeOver, setRunChangeOver] = useState(false);
  const [loginError, setLoginError] = useState(false);
  // const [andonstatus, setAndonstatus] = useState(null);

  const [active, setActive] = useState(false);
  const [andonLoading, setAndonLoading] = useState(false);

  const [__andonstatus, setAndonstatus] = useState(null);
  const [andonBlock, setAndonBlock] = useState(null);

  const [notiModalVisible, setNotiModalVisible] = useState(false);

  // setAndonBlock(props.andonBlock);
  // setAndonstatus(props.andonstatus);

  const dispatch = useDispatch();

  // console.log(props.settingValues);





  // console.log(props.andonBlock);

  const getBgColor = () => {
    return currentAndonStatus === 'Andon Red' ? 'maintenence' :
      currentAndonStatus === 'Andon Green' ? 'run' :
        currentAndonStatus === 'Andon Orange' ? 'runmode' :
          currentAndonStatus === 'Andon Blue' ? 'blue' :
            ""
  }


  const handleCloseCallBack = (saved) => {
    // fetchAndonDetail();
    setShowIssue(false);
    props.handleAndonStatusCallback(saved);
  };

  useEffect(() => {
    let __generatedAdon = { ...andonstatus?.andonDict };
    let selectedPid = __generatedAdon?.pid;
    if (selectedPid) {
      let _selectedAndon = props.settingValues["paramInfo"][selectedPid.key];
      if (andonstatus.currentAndonStage !== 'start') {
        let index = _selectedAndon.flow.findIndex(x => x === andonstatus.currentAndonStage);
        let nextMode = _selectedAndon.flow[index + 1];
        console.log(nextMode, 'test');
        if (nextMode === 'acknowledgeMode') {
          setBtnText("Acknowledge Mode")
        };
        if (nextMode === 'runMode') {
          setBtnText("Run Mode")
        };
        if (nextMode === 'endMode') {
          setBtnText("Andon Call")
        };
      } else {
        setShowIssue(false);
        setBtnText('Andon Call')
      }
    }
    setAndonLoading(false);
  }, [JSON.stringify(andonstatus)])


  useEffect(() => {
    // fetchAndonDetail();
    if (!showIssue) {
      setAndonLoading(true);
      liracrypt
        .get("/linedashboard/andonstatus", { lid: props.selectedLid })
        .then(({ data }) => {
          dispatch({
            type: 'andonStatus',
            payload: {
              andonColor: data.data.andonColor === 'G' ? 'Andon Green' :
                data.data.andonColor === 'R' ? 'Andon Red' :
                  data.data.andonColor === 'O' ? 'Andon Orange' :
                    data.data.andonColor === 'B' ? 'Andon Blue' :
                      'Andon Green',
              andonData: data.data
            }
          });
          setAndonstatus(data.data);
          // setAndonBlock(data.data.escDetails);
          let __generatedAdon = { ...data.data?.andonDict };
          let selectedPid = __generatedAdon?.pid;
          if (selectedPid) {
            let _selectedAndon = props.settingValues["paramInfo"][selectedPid.key];
            if (data.data.currentAndonStage !== 'start') {
              let index = _selectedAndon.flow.findIndex(x => x === data.data.currentAndonStage);
              let nextMode = _selectedAndon.flow[index + 1];
              if (nextMode === 'acknowledgeMode') {
                setBtnText("Acknowledge Mode")
              };
              if (nextMode === 'runMode') {
                setBtnText("Run Mode")
              };
              if (nextMode === 'endMode') {
                setBtnText("Andon Call")
              };
            }
          }
          setAndonLoading(false);
          if (
            data.data.andonColor === "G" &&
            data.data.timeSinceLastAndon &&
            moment
              .utc()
              .diff(
                moment.utc(data.data.timeSinceLastAndon, "YYYY-MM-DD HH:mm:ss"),
                "seconds"
              ) < 5
          ) {
            // Modal.warning({
            //   title: "Please fill in the 4M Request for this Issue.",
            // });
          }
        })
        .catch(function (error) {
          setAndonLoading(false);
          console.log("Error****:", error);
          if (error.response !== undefined) {
            if (error.response.status !== 401) {
              // ApiErrorComp(error.response.status);
            } else {
              setLoginError(true);
            }
          }
        });
    }

  }, [showIssue]);

  useEffect(() => {
    liracrypt
      .get("/linedashboard/andonstatus", { lid: props.selectedLid })
      .then(({ data }) => {
        setAndonBlock(data.data.escDetails);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);


  const toggleIssueDiv = (isandon) => {
    setShowIssue(true);
    setIsAndonCall(isandon);
  }

  return (
    andonLoading ? <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      alignContent: 'center',
    }}>{antIcon}</div> :
      <>
        <NotificationModal
          visible={notiModalVisible}
          setVisible={setNotiModalVisible}
          lid={props.lid}
        />
        {andonstatus && andonBlock ? (
          <React.Fragment>
            <Row>
              <Col xs={24} sm={24} md={12} lg={12}>
                <div style={{ color: "#6d6d6d" }}>
                  {andonstatus ? (
                    <ElapsedTime
                      lastTime={andonstatus.timeSinceLastAndon}
                      static={andonstatus.andonColor === "G"}
                    />
                  ) : null}
                  {
                    (!showIssue && currentAndonStatus !== 'Andon Green') ?
                      <div className="LineContainer">
                        <StablePrime autoUpdate={true} editSingleColumn={true} zenTable={true} url={'/linedash/andonstatustable'} data={{ lid: props.selectedLid }} identity="DataTable" />
                      </div> : <></>
                  }
                </div>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12}>
                <>
                  <div className="Andon">
                    <Row>
                      <Col span={24}>
                        <div
                          className="LineContainer"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            // alignItems: "center",
                            flex: 1,
                            flexDirection: "column",
                          }}
                        >
                          <div
                            style={{
                              fontWeight: 600,
                              fontSize: "18px",
                              marginLeft: "2px",
                              color: "#6d6d6d"
                            }}
                          >
                            Andon Status
                          </div>
                          <div style={{ width: "100%", marginTop: "1px" }}>
                            {currentAndonStatus === 'Andon Green' ? (
                              <>
                                <div style={{ width: "100%" }}>
                                  {" "}
                                  <p
                                    className={`txtInfo andonStatus ${getBgColor()}`}
                                    style={{
                                      borderRadius: "7px",
                                      minWidth: "100%",
                                      color: "#fff",
                                      textAlign: "center",
                                      backgroundColor: "#3b3b3b",
                                      fontSize: "30px",
                                      paddingTop: "10px",
                                      paddingBottom: "10px",
                                      fontWeight: 600,
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {(andonstatus?.andonDict?.pid && andonstatus?.andonDict?.pid?.val)
                                      ? andonstatus?.andonDict?.pid?.val
                                      : "Running"}
                                  </p>
                                </div>
                              </>
                            ) : currentAndonStatus === 'Andon Red' ? (
                              <div style={{ marginTop: "1px", width: "100%" }}>
                                {" "}
                                <p
                                  className="txtInfo andonStatus maintenence"
                                  style={{
                                    borderRadius: "7px",
                                    minWidth: "100%",
                                    color: "#fff",
                                    textAlign: "center",
                                    backgroundColor: "#3b3b3b",
                                    fontSize: "30px",
                                    paddingTop: "10px",
                                    paddingBottom: "10px",
                                    fontWeight: 600,
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <span
                                    style={{
                                      fontWeight: 600,
                                      fontSize: "30px",
                                      textTransform: "uppercase",
                                    }}
                                  >
                                    {(andonstatus?.andonDict?.pid && andonstatus?.andonDict?.pid?.val)
                                      ? andonstatus?.andonDict?.pid?.val
                                      : "Maintenance"}
                                  </span>
                                </p>
                              </div>
                            ) : (
                              <div style={{ marginTop: "1px", width: "100%" }}>
                                {" "}
                                <p
                                  className="txtInfo andonStatus runmode"
                                  style={{
                                    borderRadius: "7px",
                                    minWidth: "100%",
                                    color: "#fff",
                                    textAlign: "center",
                                    backgroundColor: "#3b3b3b",
                                    fontSize: "30px",
                                    paddingTop: "10px",
                                    paddingBottom: "10px",
                                    fontWeight: 600,
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <span
                                    style={{
                                      fontWeight: 600,
                                      fontSize: "30px",
                                      textTransform: "uppercase",
                                    }}
                                  >
                                    {(andonstatus?.andonDict?.pid && andonstatus?.andonDict?.pid?.val)
                                      ? andonstatus?.andonDict?.pid?.val
                                      : "Maintenance"}
                                  </span>
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </Col>
                      {
                        andonstatus && !showIssue ? (
                          <Col span={24} style={{ marginBottom: 10, minHeight: 180, display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                            <button className="btn-mnx"
                              onClick={() => toggleIssueDiv(btnText === 'Andon Call')}
                              style={{ fontWeight: 600, borderRadius: "10px", float: 'right' }}>{btnText}</button>
                          </Col>
                        ) : null
                      }
                    </Row>
                  </div>
                </>
              </Col>
            </Row>

            <div>
              {showIssue ? (
                <Row>
                  <Col xs={24} sm={24} md={12} lg={12}>
                    {andonstatus.timeSinceLastAndon &&
                      andonstatus?.andonDict?.pid &&
                      andonstatus?.andonDict?.pid?.val !== "Running" ? (
                      <div className="LineContainer">
                        <StablePrime autoUpdate={true} editSingleColumn={true} zenTable={true} url={'/linedash/andonstatustable'} data={{ lid: props.selectedLid }} identity="DataTable" />
                      </div>
                    ) : null}
                    {andonstatus.andonColor !== "G" ? (
                      <React.Fragment>
                        {andonstatus &&
                          andonstatus.victim &&
                          andonstatus.victim.name ? (
                          <div className="LineContainer">
                            <div className="middleAlign">
                              <span>Victim</span>
                            </div>
                            <div className="middleAlign">
                              <span className="txtInfo">
                                {andonstatus.victim.name}
                              </span>
                            </div>
                          </div>
                        ) : null}
                        {andonstatus &&
                          andonstatus.issue &&
                          andonstatus.issue.name ? (
                          <div className="LineContainer">
                            <div className="middleAlign">
                              <span style={{ fontWeight: 600 }}>Issue</span>
                            </div>
                            <div className="middleAlign">
                              <span
                                className="txtInfo"
                                style={{ fontWeight: 600 }}
                              >
                                {andonstatus.issue.name}
                              </span>
                            </div>
                          </div>
                        ) : null}

                        {andonstatus &&
                          andonstatus.attender &&
                          andonstatus.attender.name &&
                          andonstatus.andonColor !== "R" ? (
                          <div className="LineContainer">
                            <div className="middleAlign">
                              <span style={{ fontWeight: 600 }}>
                                Attender
                              </span>
                            </div>
                            <div className="middleAlign">
                              <span
                                className="txtInfo"
                                style={{ fontWeight: 600 }}
                              >
                                {andonstatus.attender.name}
                              </span>
                            </div>
                          </div>
                        ) : null}
                        {andonstatus && andonstatus.idleOperators ? (
                          <div className="LineContainer">
                            <div className="middleAlign">
                              <span>Idle Operators</span>
                            </div>
                            <div className="middleAlign">
                              <span className="txtInfo">
                                {Math.floor(andonstatus.idleOperators)}
                              </span>
                            </div>
                          </div>
                        ) : null}
                        {andonstatus &&
                          andonstatus.Victim &&
                          andonstatus.victim.MTTR ? (
                          <div className="LineContainer">
                            <div className="middleAlign">
                              <span>MTTR</span>
                            </div>
                            <div className="middleAlign">
                              <span className="txtInfo">
                                {andonstatus.victim.MTTR}
                              </span>
                            </div>
                          </div>
                        ) : null}
                        {andonstatus &&
                          andonstatus.Victim &&
                          andonstatus.victim.LastEvent ? (
                          <div className="LineContainer">
                            <div className="middleAlign">
                              <span>Last Event</span>
                            </div>
                            <div className="middleAlign">
                              <span className="txtInfo">
                                {andonstatus.victim.LastEvent}
                              </span>
                            </div>
                          </div>
                        ) : null}
                      </React.Fragment>
                    ) : null}
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12}>
                    <NewGenerateIssue
                      onSubmit={props.onSubmit}
                      isAndonCall={isAndonCall}
                      settingValues={props.settingValues}
                      addonstatus={{ ...andonstatus }}
                      changeMode={(btn) => {
                        setShowIssue(false);
                        if (btn) {
                          setBtnText(btn);
                        }
                      }}
                      handleCloseCallBack={handleCloseCallBack}
                      selectedLid={props.selectedLid}
                    />
                  </Col>
                </Row>
              ) : (
                <></>
              )}
            </div>

            <SessionError visible={loginError} />

          </React.Fragment>
        ) : (
          <></>
        )}
      </>
  );
};
export default Andon;
